import { useMemo, useState } from "react";
import type { VillageViewModel } from "../../../domain/contracts";

export type VillageSortKey = "survivors-desc" | "az" | "za";

type VillageSortingState = {
  sortKey: VillageSortKey;
  setSortKey: (next: VillageSortKey) => void;
  sortedVillages: VillageViewModel[];
};

export function useVillageSorting(villages: VillageViewModel[]): VillageSortingState {
  const [sortKey, setSortKey] = useState<VillageSortKey>("survivors-desc");

  const sortedVillages = useMemo(() => {
    const next = [...villages];
    switch (sortKey) {
      case "az":
        return next.sort((left, right) => left.title.localeCompare(right.title));
      case "za":
        return next.sort((left, right) => right.title.localeCompare(left.title));
      case "survivors-desc":
      default:
        return next.sort((left, right) => right.stats.survivorAccountCount - left.stats.survivorAccountCount);
    }
  }, [sortKey, villages]);

  return {
    sortKey,
    setSortKey,
    sortedVillages,
  };
}
